/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportConfigSlotRepresentation
 */
export interface ReportConfigSlotRepresentation {
    /**
     * 
     * @type {string}
     * @memberof ReportConfigSlotRepresentation
     */
    widgetKey: string;
    /**
     * 
     * @type {number}
     * @memberof ReportConfigSlotRepresentation
     */
    slot: number;
    /**
     * 
     * @type {string}
     * @memberof ReportConfigSlotRepresentation
     */
    displayMode: string;
}

/**
 * Check if a given object implements the ReportConfigSlotRepresentation interface.
 */
export function instanceOfReportConfigSlotRepresentation(value: object): value is ReportConfigSlotRepresentation {
    if (!('widgetKey' in value) || value['widgetKey'] === undefined) return false;
    if (!('slot' in value) || value['slot'] === undefined) return false;
    if (!('displayMode' in value) || value['displayMode'] === undefined) return false;
    return true;
}

export function ReportConfigSlotRepresentationFromJSON(json: any): ReportConfigSlotRepresentation {
    return ReportConfigSlotRepresentationFromJSONTyped(json, false);
}

export function ReportConfigSlotRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportConfigSlotRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'widgetKey': json['widgetKey'],
        'slot': json['slot'],
        'displayMode': json['displayMode'],
    };
}

export function ReportConfigSlotRepresentationToJSON(json: any): ReportConfigSlotRepresentation {
    return ReportConfigSlotRepresentationToJSONTyped(json, false);
}

export function ReportConfigSlotRepresentationToJSONTyped(value?: ReportConfigSlotRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'widgetKey': value['widgetKey'],
        'slot': value['slot'],
        'displayMode': value['displayMode'],
    };
}

